"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var BaseController_1 = require("../../../../../../shared/controllers/BaseController");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var webAApi_1 = require("../../../../../api/webAApi");
var BonusTournamentsBotsListCtl = /** @class */ (function (_super) {
    __extends(BonusTournamentsBotsListCtl, _super);
    function BonusTournamentsBotsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_usr_player_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_player_id; });
        _this.dk_usr_player_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_player_login; });
        _this.dk_lucky_percent_x100_min = UIUtils_1.UIUtils.IProp2Str(function (o) { o.lucky_percent_x100_min; });
        _this.dk_lucky_percent_x100_max = UIUtils_1.UIUtils.IProp2Str(function (o) { o.lucky_percent_x100_max; });
        _this.dk_join_tournament_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.join_tournament_type_code; });
        _this.dk_join_tournament_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.join_tournament_type_title; });
        _this.dk_join_seconds_min = UIUtils_1.UIUtils.IProp2Str(function (o) { o.join_seconds_min; });
        _this.dk_join_seconds_max = UIUtils_1.UIUtils.IProp2Str(function (o) { o.join_seconds_max; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this.dk_bonus_tournament_game_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_tournament_game_id; });
        _this.dk_gws_gameprovider_game_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gws_gameprovider_game_title; });
        _this.dk_bot_total_win = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bot_total_win; });
        _this._errDialog = errDialog;
        return _this;
    }
    BonusTournamentsBotsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    BonusTournamentsBotsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "object with id [" + id + "] not found !";
    };
    BonusTournamentsBotsListCtl.prototype.LoadData = function (bonusTournamentId, onDone) {
        var _this = this;
        webAApi_1.ListTournamentBotsByTournamentIdGet.exec({
            bonus_tournament_id: bonusTournamentId
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    usr_player_id: resp.list[i].usr_player_id,
                    usr_player_login: resp.list[i].usr_player_login,
                    lucky_percent_x100_min: resp.list[i].lucky_percent_x100_min,
                    lucky_percent_x100_max: resp.list[i].lucky_percent_x100_max,
                    join_tournament_type_code: resp.list[i].join_tournament_type_code,
                    join_tournament_type_title: resp.list[i].join_tournament_type_title,
                    join_seconds_min: resp.list[i].join_seconds_min,
                    join_seconds_max: resp.list[i].join_seconds_max,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    description: resp.list[i].description,
                    is_locked: resp.list[i].is_locked,
                    bonus_tournament_game_id: resp.list[i].bonus_tournament_game_id,
                    gws_gameprovider_game_title: resp.list[i].gws_gameprovider_game_title,
                    bot_total_win: resp.list[i].bot_total_win
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BonusTournamentsBotsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddTournamentBot.exec({
            data: {
                bonus_tournament_id: data.bonus_tournament_id,
                usr_player_id: data.usr_player_id,
                lucky_percent_x100_min: data.lucky_percent_x100_min,
                lucky_percent_x100_max: data.lucky_percent_x100_max,
                join_tournament_type_code: data.join_tournament_type_code,
                join_seconds_min: data.join_seconds_min,
                join_seconds_max: data.join_seconds_max,
                description: data.description,
                is_locked: data.is_locked,
                bonus_tournament_game_id: data.bonus_tournament_game_id
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                usr_player_id: data.usr_player_id,
                usr_player_login: resp.usr_player_login,
                lucky_percent_x100_min: data.lucky_percent_x100_min,
                lucky_percent_x100_max: data.lucky_percent_x100_max,
                join_tournament_type_code: data.join_tournament_type_code,
                join_tournament_type_title: resp.join_tournament_type_title,
                join_seconds_min: data.join_seconds_min,
                join_seconds_max: data.join_seconds_max,
                date_changed2: moment(resp.date_changed_uts_ms).utc(false),
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                description: data.description,
                is_locked: data.is_locked,
                bonus_tournament_game_id: data.bonus_tournament_game_id,
                gws_gameprovider_game_title: resp.bonus_tournament_game_title,
                bot_total_win: 0
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BonusTournamentsBotsListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditTournamentBot.exec({
                data: {
                    bonus_tournament_bot_id: data.key,
                    usr_player_id: data.usr_player_id,
                    lucky_percent_x100_min: data.lucky_percent_x100_min,
                    lucky_percent_x100_max: data.lucky_percent_x100_max,
                    join_tournament_type_code: data.join_tournament_type_code,
                    join_seconds_min: data.join_seconds_min,
                    join_seconds_max: data.join_seconds_max,
                    description: data.description,
                    is_locked: data.is_locked
                }
            }, function (resp) {
                _tmp.usr_player_id = data.usr_player_id;
                _tmp.usr_player_login = resp.usr_player_login;
                _tmp.lucky_percent_x100_min = data.lucky_percent_x100_min;
                _tmp.lucky_percent_x100_max = data.lucky_percent_x100_max;
                _tmp.join_tournament_type_code = data.join_tournament_type_code;
                _tmp.join_tournament_type_title = resp.join_tournament_type_title;
                _tmp.join_seconds_min = data.join_seconds_min;
                _tmp.join_seconds_max = data.join_seconds_max;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.description = data.description;
                _tmp.is_locked = data.is_locked;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BonusTournamentsBotsListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    BonusTournamentsBotsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteTournamentBot.exec({
                data: {
                    bonus_tournament_bot_id: key
                }
            }, function (resp) {
                _this.RemoveItem(key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BonusTournamentsBotsListCtl.prototype.generateWins = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoGenerateBotFutureWinsSequence.exec({
                data: {
                    bonus_tournament_bot_id: key
                }
            }, function (resp) {
                _tmp.bot_total_win = resp.total_win;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BonusTournamentsBotsListCtl.prototype.DoSetIsLocked = function (key, IsLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetTournamentBotIsLocked.exec({ data: { bonus_tournament_bot_id: key, is_locked: IsLocked } }, function (resp) {
                _tmp.is_locked = IsLocked;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return BonusTournamentsBotsListCtl;
}(BaseController_1.BaseController));
exports.BonusTournamentsBotsListCtl = BonusTournamentsBotsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_tournament/ctl/options/BonusTournamentsBotsListCtl.ts
// module id = 1021
// module chunks = 0